<template>
  <div id="investor_relations" class="">
    <div class="cont">
      <SliderSection id="investor-card" :obj="investorRepo" method="getPage" sliderHolder="investorRelations" :data="info" />
    </div>
  </div>
</template>

<script>
import SliderSection from '../../components/sections/SliderSection'
import InvestorRelationSliderRepository from '../../repositories/InvestorRelationSliderRepository'
import $ from 'jquery'
// import BundleSliderRepository from '../../repositories/BundleSliderRepository'
export default {
  components: { SliderSection },
  name: 'InvestorRelations',
  data () {
    return {
      investorRepo: new InvestorRelationSliderRepository(),
      info: {
        main: { sectionId: 'investor_relations', cardType: 'investor-relations', title: this.$t('investorCard.title'), description: '', image: '' },
        slider: []
      }
    }
  },
  mounted () {
    if (this.$lang === 'ar') {
      $('.cont').addClass('ar')
    } else {
      $('.cont').addClass('en')
    }
  },
  created () {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
#investor_relations {
  margin-top: 160px;
  min-height: calc(100vh - (160px + 285.6px));
  //background-image: url("../../assets/images/pure-background.png") ;
  //background-size: cover;
  background-image: linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  -moz-background-image: -moz-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  -o-background-image: -o-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  -webkit-background-image: -webkit-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  //.cont {
  //  background: url("../../assets/images/back1.png");
  //}
  .cont.ar {
    background: url("../../assets/images/circles-back-ar.png") no-repeat right;
  }
  .cont.en {
    background: url("../../assets/images/circles-back-en.png") no-repeat;
  }
}
@media (max-width: 1000px) {
  #investor_relations{
    min-height: calc(100vh - (170px + 392.2px));
  }
}
@media (max-width: 575px) {
  #investor_relations{
    min-height: calc(100vh - (170px + 814.6px));
  }
}
</style>
